import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { changeSortType, ESortType, IFilterItem } from 'redux/filter/filterSlice';
import { RootState, useAppDispatch, useAppSelector } from 'redux/store';
import themes from 'styles/themes';

const SortWidget = ({ setTriggerUpdateSearch }) => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const { currentSortType } = useAppSelector((state: RootState) => state.filter);
    // const [sortList, setSortList] = useState();
    const sortList = Object.keys(ESortType).map((filterItem) => ({
        title: ESortType[filterItem],
        value: ESortType[filterItem],
        isActive: ESortType[filterItem] === currentSortType,
    }));
    const handleSortClick = (sortItem: IFilterItem<ESortType>) => {
        if (sortItem.value === currentSortType) return;
        setTriggerUpdateSearch(true);
        dispatch(changeSortType(sortItem.value));
    };

    return (
        <div className={classes.sortWrap}>
            {sortList.map((sortItem) => (
                <div
                    key={sortItem.value}
                    className={clsx(classes.sortItem, sortItem.isActive && classes.selectedItem)}
                    onClick={() => handleSortClick(sortItem)}
                >
                    {sortItem.title}
                </div>
            ))}
        </div>
    );
};

export default SortWidget;

const useStyles = makeStyles(() => ({
    sortWrap: {
        marginTop: 20,
    },
    sortItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: themes.palette.primary.main,
        padding: '10px',
        cursor: 'pointer',
        '&:hover': {
            background: themes.palette.secondary['500'],
            borderRadius: '4px',
        },
    },
    selectedItem: {
        background: themes.palette.secondary['500'],
    },
}));
